import {createApp} from 'vue';
import App from './App.vue';
import router from './router';
import {store} from './store';
import './plugins';
import vuetify from './plugins/vuetify';
import {plugin as VueTippy} from 'vue-tippy';
import VCalendar from 'v-calendar';
import {VueDragula} from 'vue3-dragula';
import i18n from './plugins/i18n/i18n';
import {setupPlugins} from './plugins/init';
import {registerGlobalComponents} from './components/registerGlobals';
import {registerLayouts} from './layouts/register';
import {clearStaleAssetReloadFlag} from './utils/staleAssetReload';
import 'tippy.js/dist/tippy.css';
import 'v-calendar/style.css';

export async function bootstrapApp() {
    const app = createApp(App);

    app.use(store)
        .use(i18n)
        .use(router)
        .use(vuetify)
        .use(VueTippy, {
            directive: 'tippy',
            component: 'tippy',
        })
        .use(VCalendar, {componentPrefix: 'vc'})
        .use(VueDragula, {logging: {service: true}});

    registerGlobalComponents(app);
    setupPlugins(app, router);
    await registerLayouts(app);
    await router.isReady();

    // Remove compilerOptions if it was set by any plugin (e.g., vue-i18n)
    // Since we're using the runtime-only build, compilerOptions should only be in vite.config.mjs
    if ('compilerOptions' in app.config) {
        delete (app.config as any).compilerOptions;
    }

    app.mount('#app');
    clearStaleAssetReloadFlag();

    return app;
}